// @ts-strict-ignore
import { Component, OnInit, Inject } from '@angular/core';
import { MessageService, Message } from '@sharedServices/app-messages.service';
import { environment } from '@env/environment';
import { Project } from '@sharedAngular/definitions';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
@UntilDestroy()
@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    standalone: false
})
export class AlertMessageComponent implements OnInit {
  public _message: Message = new Message();

  public inTestEnv: boolean = environment.test;

  constructor(@Inject('project') public project: Project, private messageService: MessageService) {}

  ngOnInit() {
    this.messageService.messageChange.pipe(untilDestroyed(this)).subscribe({
      next: (message: Message) => {
        this._message = message;
      },
    });
  }
}
